(function($) {
    $.fn.equalHeight = function(options) {
        var settings = $.extend({
            context : this,
            cols : '[class^=col-]',
            target : [],
            resize : true
        }, options);

        function makeHeightEqual() {
            var colArray = settings.context.find(settings.cols);

            while(colArray.length > 0) {

                // find all elements in a row
                var rowPosTop = colArray.eq(0).offset().top;
                var colsInCurrentRow = [];
                var i = 0;
                for(i; i < colArray.length; i++) {
                    if(colArray.eq(i).offset().top > rowPosTop) break;
                }
                // split colSet in current and rest
                if(colsInCurrentRow.length == 0) {
                    colsInCurrentRow = colArray.slice(0, i);
                    colArray = colArray.slice(i);
                }

                for(var ti = 0; ti < settings.target.length; ti++) {
                    var targetSelector = settings.target[ti];
                    // get max height of target element in current row
                    var maxHeight = 0;
                    for(var i = 0; i < colsInCurrentRow.length; i++) {
                        var currentTarget = colsInCurrentRow.eq(i).find(targetSelector).first();
                        // currentTarget.outerHeight() is int so we use [0].getBoundingClientRect().height;
                        if(currentTarget.length > 0){
                            // reset min-height regarding the resize function
                            currentTarget.css('min-height', 0);
                            var tempHeight = currentTarget[0].getBoundingClientRect().height;
                            if(tempHeight > maxHeight) maxHeight = tempHeight+1;
                        }
                    }
                    var ua = window.navigator.userAgent;
                    var msie = ua.indexOf("MSIE ");
                    // set all target elements to maxHeight
                    for(var i = 0; i < colsInCurrentRow.length; i++) {
                        // If Internet Explorer, return version number
                        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                            //set strict height for flex colum/justifiy content support
                            colsInCurrentRow.eq(i).find(targetSelector).first().css('height', parseInt(maxHeight));
                        }else{
                            colsInCurrentRow.eq(i).find(targetSelector).first().css('min-height', parseInt(maxHeight));
                        }
                    }
                }
            }
        }

        if(settings.target.length < 1) return this;

        makeHeightEqual();

        if(settings.resize) {
            $(window).resize(function() {
                $(this).equalHeight($.extend(settings, {resize : false}));
            });
        }

        return this
    }
}(jQuery))
$(window).on('load',function(){
    $('.frame-type-mask_downloads.frame-container').equalHeight({
        cols:'.entry',
        target:['.img-wrap']
    });
});

$(window).on('resize', function () {
    $('.frame-type-mask_downloads.frame-container').equalHeight({
        cols:'.entry',
        target:['.img-wrap']
    });
});
